import get from 'lodash/get';
import { currencySettings } from '../constants/currency';

export default (code) => get(currencySettings, [code, 'symbol'], code);
